import { User } from '../..';

export type ActionOptions = {
  text: string;
  onClick: () => void;
};

export class ChangeRequestActionsService {
  constructor(
    private $translate: ng.translate.ITranslateService,
    private accessRightsService
  ) {
    'ngInject';
  }

  // eslint-disable-next-line complexity
  getCommentActions({
    author_id,
    profile,
    callbacks,
    isPicture,
  }: {
    author_id: string;
    profile: User;
    callbacks: { onEdit?: () => void; onDelete?: () => void };
    isPicture: boolean;
  }): ActionOptions[] {
    const { onEdit, onDelete } = callbacks;
    const isAdmin = this.accessRightsService.isAdmin();
    const isAuthor = this.isAuthor(author_id, profile);

    const editAction =
      isAuthor && onEdit
        ? [
            {
              text: this.$translate.instant('CHANGE_REQUEST_COMMENT_EDIT'),
              onClick: () => onEdit(),
            },
          ]
        : [];
    const deleteAction =
      (isAdmin || isAuthor) && onDelete
        ? [
            {
              text: this.$translate.instant('CHANGE_REQUEST_COMMENT_DELETE'),
              onClick: () => onDelete(),
            },
          ]
        : [];

    return [...editAction, ...deleteAction];
  }

  isAuthor(author_id: string, profile: User): boolean {
    return author_id === profile._id;
  }
}
